import { getSuperChatReferrer, setSuperChatReferrer } from 'ai/utils/sessionStorage';
import anaConsts from 'analytics/constants';
import { SUPERCHAT_PAGE, SOT_FIELDS } from 'ai/analytics/events';
import { ENTRYPOINTS } from 'ai/constants/superchat';
import locationUtils from 'utils/Location';
import store from 'store/Store';

const REFERRER_PREFIXES = {
    CATEGORY: 'superchat:category:',
    SEARCH: 'superchat:search:',
    PRODUCT: 'superchat:product:',
    CMS: 'superchat:cms:',
    DEFAULT: 'superchat:other'
};

export function updateDigitalDataForSuperChat() {
    const superChatReferrer = getSuperChatReferrer();

    if (typeof window !== 'undefined') {
        const { digitalData } = window;

        if (superChatReferrer && digitalData) {
            digitalData.page.pageInfo.pageName = SUPERCHAT_PAGE.PAGE_NAME;
            digitalData.page.attributes.sephoraPageInfo.pageName = anaConsts.SUPER_CHAT.SUPERCHAT_LANDING;
            digitalData.page.category.pageType = SUPERCHAT_PAGE.PAGE_TYPE;
        }
    }

    return superChatReferrer;
}

export function buildSuperChatEventFields(superChatReferrer) {
    if (!superChatReferrer) {
        return {};
    }

    return {
        [SOT_FIELDS.REFERRER]: superChatReferrer,
        pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING,
        pageType: SUPERCHAT_PAGE.PAGE_TYPE,
        pageDetail: SUPERCHAT_PAGE.PAGE_DETAIL
    };
}

export function applySuperChatAnalyticsContext() {
    const superChatReferrer = updateDigitalDataForSuperChat();

    return buildSuperChatEventFields(superChatReferrer);
}

export function calculateFreshReferrer() {
    const state = store.getState();
    const page = state?.page || {};
    const search = state?.search || {};
    const entryPointData = state?.superChat?.entryPointData;

    // CMS/Contentful entry point is not detectable via Location helpers, so the
    // referrer is derived from the entry-point context (sid) captured on open.
    if (entryPointData?.entrypoint === ENTRYPOINTS.CMS) {
        const { sid } = entryPointData;

        return sid ? `${REFERRER_PREFIXES.CMS}${sid}` : REFERRER_PREFIXES.DEFAULT;
    }

    const isProductPage = locationUtils.isProductPage();
    const isCategoryPage = locationUtils.isNthCategoryPage();
    const isSearchPage = locationUtils.isSearchPage();

    if (isCategoryPage) {
        const categoryId = page?.nthCategory?.categoryId;

        return categoryId
            ? `${REFERRER_PREFIXES.CATEGORY}${categoryId}`
            : REFERRER_PREFIXES.DEFAULT;
    }

    if (isSearchPage) {
        const searchKeyword = search?.keyword;

        return searchKeyword
            ? `${REFERRER_PREFIXES.SEARCH}${searchKeyword}`
            : REFERRER_PREFIXES.DEFAULT;
    }

    if (isProductPage) {
        const productId = page?.product?.productDetails?.productId;

        return productId
            ? `${REFERRER_PREFIXES.PRODUCT}${productId}`
            : REFERRER_PREFIXES.DEFAULT;
    }

    return REFERRER_PREFIXES.DEFAULT;
}

export function ensureFreshReferrer() {
    const freshReferrer = calculateFreshReferrer();
    setSuperChatReferrer(freshReferrer);

    return freshReferrer;
}
